import { isEmptyObject } from "utils";
import { addDoc } from "firebase/firestore";
import { getCollectionRef, now } from "./FirebaseRepository";

class LoggerRepository {
  async createLogOnDataBase(message: string, data: Object) {
    if (!message || isEmptyObject(data)) return;
    let newData = {};

    // Remove os valores undefined
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined) newData[key] = value;
    });

    const collection = getCollectionRef("logs_contract");
    await addDoc(collection, {
      message,
      data: newData,
      date: now(),
    });
  }
}

export default new LoggerRepository();
